import React, { useState, memo, useCallback } from "react";
import { TimeSlot } from "../../types/views";
import { SchedulerTheme } from "../../types/views";

interface GridCellProps {
  timeSlot: TimeSlot;
  width: number;
  height: number;
  onClick: () => void;
  onHover: (e: React.MouseEvent) => void;
  onHoverEnd: () => void;
  schedulerTheme?: SchedulerTheme;
}

const GridCell: React.FC<GridCellProps> = memo(
  ({
    timeSlot,
    width,
    height,
    onClick,
    onHover,
    onHoverEnd,
    schedulerTheme,
  }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = useCallback(() => {
      onClick();
    }, [onClick]);

    const handleMouseEnter = useCallback(
      (e: React.MouseEvent) => {
        setIsHovered(true);
        onHover(e);
      },
      [onHover]
    );

    const handleMouseLeave = useCallback(() => {
      setIsHovered(false);
      onHoverEnd();
    }, [onHoverEnd]);

    const backgroundColor = isHovered
      ? "#f5f5f5" // Keep hover color consistent
      : schedulerTheme?.getGridCellColor?.(timeSlot) || "#ffffff";

    return (
      <div
        className="grid-cell"
        style={{
          position: "relative",
          width: `${width}px`,
          height: `${height}px`,
          borderRight: "1px solid #e0e0e0",
          borderBottom: "1px solid #e0e0e0",
          backgroundColor,
          cursor: "pointer",
          transition: "background-color 0.2s",
        }}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {timeSlot.events.length > 0 && (
          <div
            className="event-indicator"
            style={{
              position: "absolute",
              top: 2,
              left: 2,
              right: 2,
              height: "4px",
              backgroundColor: "#1976d2",
              borderRadius: "2px",
            }}
          />
        )}
      </div>
    );
  }
);

GridCell.displayName = "GridCell";

export default GridCell;
